<div *ngIf="splitTextRawFields.includes(data.rawField)" class="d-flex flex-column py-2">
  @if (data.rawField !== 'text_to_split') {
  <b>
    {{ data.field | translate }}
    <span *ngIf="loggedInUserIsSysAdmin && data.to && data.to !== 'BLANK'">
      ({{ 'QUESTION_ID' | translate }}: {{ data.to }}) </span
    >:
  </b>
  <app-permission-edit [permissionName]="'View Enquiry Question'" showFallback>
    <div class="disable-truncated-text" [innerHtml]="data.from | sanitizeHtml"></div>
  </app-permission-edit>
  } @else { @for (text of data.from; track text; let i = $index) {
  <b>
    {{ data.field | translate }}
    @if(loggedInUserIsSysAdmin && data.to?.[i]){
    <span>({{ 'QUESTION_ID' | translate }}: {{ data.to?.[i] }})</span>
    }:
  </b>
  <app-permission-edit [permissionName]="'View Enquiry Question'" showFallback>
    <div class="disable-truncated-text" [innerHtml]="text | sanitizeHtml"></div>
  </app-permission-edit>
  } }
</div>
<span
  *ngIf="
    !freeTextRawFields.includes(data.rawField) &&
    !historySkipRawFields.includes(data.rawField) &&
    !jsonSemiDetailChangeCategories.includes(history.category)
  "
>
  <b>{{ data.field | translate }}</b
  >: {{ 'From' | translate }} <b>{{ data.from | translate }}</b> {{ 'To' | translate }}
  <b>{{ data.to | translate }}</b>
</span>

<span *ngIf="jsonSemiDetailChangeCategories.includes(history.category)">
  @if (history.category === 'update_watchers') {
  <span class="disable-truncated-text">
    <b>{{ data.field | translate }}</b
    >: @for (user of data.from; track user; let i = $index, isLast = $last) {
    <app-permission-edit class="d-inline-block" [permissionName]="'View Enquiry Edited By'">
      <span class="medis-clickable text-14-800-dark" (click)="previewUser(data.to[i])">
        {{ user }}
      </span>
      <fallback-content class="text-14-800-dark">*****</fallback-content>
    </app-permission-edit>
    @if (!isLast) { , } }
  </span>
  } @else {
  <b>{{ data.field | translate }}</b
  >: @if (data.rawField === 'Preview message') {
  <i
    class="fas fa-eye medis-icon ms-0"
    (click)="emailMessagePreview(history.id, data.from)"
    matTooltip="{{ 'VIEW' | translate }} {{ 'MESSAGE' | translate | lowercase }}"
  ></i>
  } @else if (['To', 'Subject'].includes(data.rawField)) {
  <app-permission-edit class="d-inline-block" [permissionName]="'View Enquiry Edited By'">
    {{ data.from | translate }}
    <fallback-content>*****</fallback-content>
  </app-permission-edit>
  } @else {
  {{ data.from | translate }}
  } }
</span>

<span *ngIf="data.rawField === 'inserted_from_draft'">
  <mat-divider class="m-2"></mat-divider>
  <b>
    <app-permission-edit class="d-inline-block" [permissionName]="'View Enquiry Edited By'">
      <span class="medis-clickable text-14-800-dark" (click)="previewUser(data.from[1])">
        {{ data.from[0] }}
      </span>
      <fallback-content class="text-14-800-dark">*****</fallback-content>
    </app-permission-edit>
  </b>
  {{ 'DRAFT_CREATED_VIA_MANUAL_INSERT' | translate }}
  <b>
    {{ data.to | dateChecker }}
  </b>
</span>

<span *ngIf="referencesRawFields.includes(data.rawField)">
  @if ((data.rawField === 'reference_question_id' && loggedInUserIsSysAdmin) || data.rawField !==
  'reference_question_id') {
  <b>{{ data.field | translate }}</b
  >: @if (data.from === data.to) {
  <b>{{ data.from }}</b>
  } @else {
  {{ 'From' | translate }} <b>{{ data.from | translate }}</b> {{ 'To' | translate }}
  <b>{{ data.to | translate }}</b>
  } }
</span>

<span *ngIf="data.rawField === 'due_date'">
  <b>{{ data.field | translate }}</b
  >:
  {{ 'From' | translate }}
  <b> {{ data.from === 'BLANK' ? (data.from | translate) : (data.from | dateChecker) }}</b>
  {{ 'To' | translate }}
  <b> {{ (data.to.includes(',') ? data.to.split(',')[0] : data.to) | dateChecker }}</b>
  <ng-container *ngIf="data.to.includes(',')">
    - {{ data.to.split(',')[1] | translate }}
  </ng-container>
</span>

<span *ngIf="data.rawField === 'notification'">
  {{ data.from | translate }}
  @if (data.to && data.to != 'BLANK') { @if (isObject(data.to)) {
  <span
    >to department <b>{{ data.to['department_name'] }}</b> at
    <b>{{ data.to['department_email'] }} </b></span
  >
  <i
    class="fas fa-eye medis-icon ms-0"
    (click)="emailMessagePreview(history.id, data.to['message_id'])"
    matTooltip="{{ 'VIEW' | translate }} {{ 'MESSAGE' | translate | lowercase }}"
  ></i>
  } @else { <span>: {{ data.to | translate }}</span
  >} }
</span>

<span
  *ngIf="
    (loggedInUserIsSysAdmin && ['question_id', 'question_ids'].includes(data.rawField)) ||
    discRawFields.includes(data.rawField)
  "
  class="disable-truncated-text"
>
  <b>{{ data.field | translate }}</b
  >: {{ data.from }}<span *ngIf="data.to?.trim() !== 'BLANK'">, {{ data.to }}</span>
</span>

<span *ngIf="data.rawField === 'reason_for_update'" class="disable-truncated-text">
  <b>{{ data.field | translate }}</b
  >: {{ data.from }}
  <span *ngIf="data.to.trim() !== 'BLANK'">{{ data.to | dateChecker }}</span>
</span>
<span *ngIf="data.rawField === 'reason_for_update_accessory'">
  {{ data.from }}
</span>

<span *ngIf="freeTextRawFields.includes(data.rawField) && data.rawField !== 'gdpr_notification'">
  <b>{{ data.field | translate }}</b
  >:
  <ng-container
    *ngTemplateOutlet="freeTextTemplate; context: { label: 'From', text: data.from, data: data }"
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="freeTextTemplate; context: { label: 'To', text: data.to, data: data }"
  ></ng-container>
</span>
<span *ngIf="data.rawField === 'inquirer'">
  <b>{{ data.field | translate }}</b
  >: {{ 'From' | translate }}
  <b class="text-14-800-dark">
    @if (!data.from.id) {
    {{ 'BLANK' | translate }}
    } @else {
    <app-permission-edit class="d-inline-block" [permissionName]="'View Enquirer'">
      <span class="medis-clickable" (click)="previewInquirer(data.from.pk())">
        {{ data.from | displayInfo }}
      </span>
      <fallback-content>*****</fallback-content>
    </app-permission-edit>
    }
  </b>
  {{ 'To' | translate }}
  <app-permission-edit class="d-inline-block text-14-800-dark" [permissionName]="'View Enquirer'">
    <b class="medis-clickable" (click)="previewInquirer(data.to.pk())">
      {{ data.to | displayInfo }}
    </b>
    <fallback-content>*****</fallback-content>
  </app-permission-edit>
</span>
<span *ngIf="data.rawField === 'inquirer_details'">
  <mat-divider></mat-divider>
  <div>
    <span [innerHtml]="data.from | sanitizeHtml"></span>
    <app-permission-edit class="d-inline-block text-14-800-dark" [permissionName]="'View Enquirer'">
      <b class="medis-clickable" (click)="previewInquirer(data.to.pk())">
        {{ data.to | displayInfo }}
      </b>
      <fallback-content>*****</fallback-content>
    </app-permission-edit>
  </div>
</span>
<span>
  <div
    *ngIf="
      data.rawField === 'team_update_details' ||
      data.rawField === 'assignment_removal_on_team_update_details'
    "
  >
    <span>
      <b>{{ 'COUNTRY' | translate }}</b
      >: {{ 'From' | translate }}
      <b>{{ data.from.split(',')[0] }}</b>
      {{ 'To' | translate }}
      <b>{{ data.from.split(',')[1] }}</b>
    </span>
  </div>
  <div
    *ngIf="
      data.rawField === 'assignment_removal_on_team_update_details' ||
      data.rawField === 'assignment_removal_on_role_archive_details'
    "
  >
    <span>
      <b>{{ 'PERSONAL_ASSIGNMENT' | translate }}</b
      >:
      {{ 'From' | translate }}
      <b>{{ data.from.split(',')[2] }}</b>
      {{ 'To' | translate }}
      <b>{{ data.from.split(',')[3] }}</b>
    </span>
  </div>
  <div *ngIf="data.rawField === 'assignment_removal_on_role_archive_details'">
    <span>
      <b>{{ 'ARCHIVED_ROLE' | translate }}</b
      >:
      <b>{{ data.from.split(',')[0] }}</b>
      {{ 'IN' | translate }} {{ 'TEAM' | translate | lowercase }}
      <b>{{ data.from.split(',')[1] }}</b>
    </span>
  </div>
</span>
<span *ngIf="data.rawField === 'gdpr_notification'">
  <b>{{ data.field | translate }}</b>
  <mat-divider></mat-divider>
  <div class="text-max-height mt-2 white-space-normal" [innerHtml]="data.from | sanitizeHtml"></div>
</span>
<span *ngIf="['merge_as_inquiry', 'merge_as_new_inquiry'].includes(data.rawField)">
  <ng-container *ngFor="let fromObj of getFromData(data)">
    <ng-template #templateMergedPreviouslyFrom>
      <ng-container *ngIf="fromObj.mergedFromId">
        ({{ 'MERGED_PREVIOUSLY_FROM' | translate }}
        <a [href]="resolveInteractionUrl(fromObj.mergedFromId)" class="clickable">{{
          fromObj.mergedFromId
        }}</a
        >)
      </ng-container>
    </ng-template>
    <ng-template #templateFromInteractionId>
      {{ 'FROM_INTERACTION_ID' | translate }}
      {{
        history.category === 'closed_as_merge'
          ? history.interactionId
          : history.mergeOrDuplicateParam
      }}
    </ng-template>
    <ng-template #templateInInteractionId>
      {{ 'IN_INTERACTION_ID' | translate }}
      {{
        history.category === 'closed_as_merge'
          ? history.mergeOrDuplicateParam
          : history.interactionId
      }}
    </ng-template>
    <ng-container *ngIf="loggedInUserIsSysAdmin">
      {{ 'COLUMN_QUESTION_ID' | translate }} {{ fromObj.id }}
      <ng-container *ngTemplateOutlet="templateFromInteractionId"></ng-container>
      <ng-container *ngTemplateOutlet="templateMergedPreviouslyFrom"></ng-container>
      {{ 'VIA' | translate }} {{ fromObj.channel | translate | lowercase }}
      <span *ngIf="data.rawField === 'merge_as_inquiry'">
        {{ 'MERGED_INTO_QUESTION_IDS' | translate }} {{ data.to }}
        <ng-container *ngTemplateOutlet="templateInInteractionId"></ng-container>
      </span>
    </ng-container>
    <ng-container *ngIf="!loggedInUserIsSysAdmin">
      {{ 'QUESTION' | translate }}
      <ng-container *ngTemplateOutlet="templateFromInteractionId"></ng-container>
      <ng-container *ngTemplateOutlet="templateMergedPreviouslyFrom"></ng-container>
      {{ 'VIA' | translate }} {{ fromObj.channel | translate | lowercase }}
      <span *ngIf="data.rawField === 'merge_as_inquiry'">
        {{ 'MERGED_INTO_QUESTIONS' | translate }}
        <ng-container *ngTemplateOutlet="templateInInteractionId"></ng-container>
      </span>
    </ng-container>
    :
    <app-permission-edit [permissionName]="'View Enquiry Question'" showFallback>
      <div class="text-max-height" [innerHtml]="fromObj.text | sanitizeHtml"></div>
    </app-permission-edit>
  </ng-container>
</span>

<ng-template #freeTextTemplate let-label="label" let-text="text" let-data="data">
  <div class="medis-flex-container-between">
    {{ label | translate }}
    <mat-divider></mat-divider>
  </div>
  @if (data.permissionName) {
  <app-permission-edit [permissionName]="data.permissionName" showFallback>
    <div class="text-max-height" [innerHtml]="text | sanitizeHtml"></div>
  </app-permission-edit>
  } @else {
  <div class="text-max-height" [innerHtml]="text | sanitizeHtml"></div>
  }
</ng-template>
